import React, { Component } from 'react';
import { Row, Col, Button, Divider } from 'antd';
import moment from 'moment';
class NiprSummary extends Component {
    getbgs = (quno, anslist) => {
        let { appoinment } = this.props;
        
        const ans = appoinment.background && (appoinment.background.find(z => z.queS_NUMBER === quno) && appoinment.background.find(z => z.queS_NUMBER === quno).queS_RESPONSE);
        const com = " " + (appoinment.background.find(z => z.queS_NUMBER === quno) && appoinment.background.find(z => z.queS_NUMBER === quno).comments ? appoinment.background.find(z => z.queS_NUMBER === quno).comments : "");
        const type = ans && anslist && anslist.find(x => x.lI_RESPONSE_KEY === ans) && anslist.find(x => x.lI_RESPONSE_KEY === ans).lI_NQA_TYPE;
        if (type === "TXT")
            return ans;
        else if (type === "RB") {
            return (anslist.find(x => x.lI_RESPONSE_KEY === ans) ? anslist.find(x => x.lI_RESPONSE_KEY === ans).lI_RESPONSE : 'none') + com
        } else if (type === "MCS") {
            return (anslist.filter(x => x.lI_RESPONSE_KEY === ans).length > 0 ? anslist.filter(x => x.lI_RESPONSE_KEY === ans).map((x, i) => {
                return anslist.filter(x => x.lI_RESPONSE_KEY === ans).length === i + 1 ? x.lI_RESPONSE : x.lI_RESPONSE + ", "
            }) : 'none')

        }

    }
    getnqs = (quno, anslist) => {
        let { noN_UNIFORM } = this.props;
        let ans = noN_UNIFORM && noN_UNIFORM.find(z => z.keY_VALUE === quno) && noN_UNIFORM.find(z => z.keY_VALUE === quno).value
        const type = ans && anslist && anslist.find(x => x.lI_RESPONSE_KEY === ans) && anslist.find(x => x.lI_RESPONSE_KEY === ans).lI_NQA_TYPE;
        if (type === "TXT")
            return ans;
        else if (type === "RB") {
            return (anslist.find(x => x.lI_RESPONSE_KEY === ans) ? anslist.find(x => x.lI_RESPONSE_KEY === ans).lI_RESPONSE : 'none')
        } else if (type === "MCS") {
            
            ans = noN_UNIFORM && noN_UNIFORM.filter(z => z.keY_VALUE === quno).length > 0 && noN_UNIFORM.filter(z => z.keY_VALUE === quno).map(x => x.value);
            return ans.map((a,i) => {
                return anslist.find(x => x.lI_RESPONSE_KEY === a) ? anslist.find(x => x.lI_RESPONSE_KEY === a).lI_RESPONSE +(i+1===ans.length?' ':', ') : ''
            });




        }
        return
    }
    render() {
        let { appoinment, nuqs, bqs, States } = this.props;

        return (
            appoinment ?
                <div>
                    <div className="mi_main" >
                        <Row span={24}>
                            <Col span={15}>
                                <p className='mi_title' style={{ color: '#fd828d' }}>Biographic Data</p>
                            </Col>
                        </Row>

                        <div>
                            <Row>
                                <Col md={6} sm={24}>
                                    <p className="mi_name">Last Name</p>
                                    <p className="mi_value">{appoinment.firM_OR_LAST_NAME ? appoinment.firM_OR_LAST_NAME : "none"}</p>
                                </Col>
                                <Col md={6} sm={24}>
                                    <p className="mi_name">First Name</p>
                                    <p className="mi_value">{appoinment.firsT_NAME ? appoinment.firsT_NAME : "none"}</p>
                                </Col>
                                <Col md={6} sm={24}>
                                    <p className="mi_name">Middle Name</p>
                                    <p className="mi_value">{appoinment.middlE_NAME ? appoinment.middlE_NAME : "none"}</p>
                                </Col>
                                <Col md={6} sm={24}>
                                    <p className="mi_name">Suffix</p>
                                    <p className="mi_value">{appoinment.suffiX_NAME ? appoinment.suffiX_NAME : "none"}</p>
                                </Col>
                                <Col md={6} sm={24}>
                                    <p className="mi_name">Gender</p>
                                    <p className="mi_value">{appoinment.gender ? (appoinment.gender === "M" ? "Male" : "Female") : "none"}</p>
                                </Col>
                                <Col md={6} sm={24}>
                                    <p className="mi_name">Date of Birth</p>
                                    <p className="mi_value">{appoinment.birtH_DATE ? moment(appoinment.birtH_DATE).format("MM/DD/YYYY") : "none"}</p>
                                </Col>
                                <Col md={6} sm={24}>
                                    <p className="mi_name">FINRA Individual CRD</p>
                                    <p className="mi_value">{appoinment.nasD_CRD ? appoinment.nasD_CRD : "none"}</p>
                                </Col>

                            </Row>
                        </div>
                    </div>

                    <div className="mi_main" >
                        <Row span={24}>
                            <Col span={15}>
                                <p className='mi_title' style={{ color: '#fd828d' }}>Address</p>
                            </Col>
                        </Row>
                        {appoinment.address && appoinment.address.map((x, i) => {
                            return <div key={i}>
                                <p className='mi_address_card'>{x.addresS_CODE === "01" ? "Resident Address" : (x.addresS_CODE === "02" ? "Business Address" : "Mailing Address")}</p>

                                <Row>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">Address Line 1</p>
                                        <p className="mi_value">{x.addR_LINE_1 ? x.addR_LINE_1 : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">Address Line 2</p>
                                        <p className="mi_value">{x.addR_LINE_2 ? x.addR_LINE_2 : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">Address Line 2</p>
                                        <p className="mi_value">{x.addR_LINE_3 ? x.addR_LINE_3 : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">City</p>
                                        <p className="mi_value">{x.city ? x.city : "none"}</p>
                                    </Col>

                                    <Col md={6} sm={24}>
                                        <p className="mi_name">State</p>
                                        <p className="mi_value">{x.statE_CODE ? States.find(y => y.code === x.statE_CODE).name : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">Country</p>
                                        <p className="mi_value">{x.countrY_CODE ? "United States of America" : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">ZIP</p>
                                        <p className="mi_value">{x.ziP_CODE ? x.ziP_CODE : "none"}</p>
                                    </Col>
                                </Row>
                            </div>
                        })}


                    </div>
                    <div className="mi_main" >
                        <Row span={24}>
                            <Col span={15}>
                                <p className='mi_title' style={{ color: '#fd828d' }}>Phone Contact</p>
                            </Col>
                        </Row>
                        <Row>
                            {appoinment.phone && appoinment.phone.map((x, i) => {
                                return <Col key={i} md={12} sm={24}>
                                    <p className='mi_address_card'>{x.phonE_CODE === "01" ? "Home Phone Number" : (x.phonE_CODE === "02" ? "Business Phone Number" : "Fax Number")}</p>

                                    <Row>
                                        <Col sm={18}>
                                            <p className="mi_name">Number</p>
                                            <p className="mi_value">{x.phonE_NUMBER ? x.phonE_NUMBER : "none"}</p>
                                        </Col>
                                        {x.phonE_CODE !== "05" ? <Col sm={6}>
                                            <p className="mi_name">Ext</p>
                                            <p className="mi_value">{x.phonE_EXTENSION ? x.phonE_EXTENSION : "none"}</p>
                                        </Col> : ""}

                                    </Row>

                                </Col>
                            })}
                        </Row>

                    </div>
                    <div className="mi_main" >
                        <Row span={24}>
                            <Col span={15}>
                                <p className='mi_title' style={{ color: '#fd828d' }}>Web Information</p>
                            </Col>
                        </Row>
                        <Row>
                            {appoinment.email && appoinment.email.map((x, i) => {
                                return <Col key={i} md={12} sm={24}>
                                    <p className='mi_address_card'>{x.emaiL_CODE === "01" ? "Personal Email" : "Business Email"}</p>
                                    <p className="mi_name">EmaiL</p>
                                    <p className="mi_value">{x.emaiL_ADDRESS ? x.emaiL_ADDRESS : "none"}</p>
                                </Col>

                            })}
                        </Row>
                        <Row>
                            <Col md={6} sm={24}>
                                <p className="mi_name">Website</p>
                                <p className="mi_value">{appoinment.website ? appoinment.website : "none"}</p>
                            </Col>
                        </Row>
                    </div>
                    {appoinment.name ?
                        <div className="mi_main" >
                            <Row span={24}>
                                <Col span={15}>
                                    <p className='mi_title' style={{ color: '#fd828d' }}>Aliases</p>
                                </Col>
                            </Row>
                            {appoinment.name.map((x, i) => {

                                return i !== 0 ?
                                    <Row key={i}>
                                        <Col md={6} sm={24}>
                                            <p className="mi_name">Firm or Last Name</p>
                                            <p className="mi_value">{x.firM_OR_LAST_NAME ? x.firM_OR_LAST_NAME : "none"}</p>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <p className="mi_name">First Name</p>
                                            <p className="mi_value">{x.firsT_NAME ? x.firsT_NAME : "none"}</p>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <p className="mi_name">Middle Name</p>
                                            <p className="mi_value">{x.middlE_NAME ? x.middlE_NAME : "none"}</p>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <p className="mi_name">Alternative Name Type</p>
                                            <p className="mi_value">{x.namE_CODE ? (x.namE_CODE === 2 ? "Alias" : (x.namE_CODE === 3 ? "Doing Business As" : "Formerly Known As")) : "none"}</p>
                                        </Col>
                                    </Row> : ""


                            })}


                        </div> : ""}
                    {appoinment.affiliation ?
                        <div className="mi_main" >
                            <Row span={24}>
                                <Col span={15}>
                                    <p className='mi_title' style={{ color: '#fd828d' }}>Affiliations</p>
                                </Col>
                            </Row>
                            {appoinment.affiliation.map((x, i) => {
                                return <div key={i}>

                                    <Row>
                                        <Col md={6} sm={24}>
                                            <p className="mi_name">Agency Name</p>
                                            <p className="mi_value">{x.entitY_NAME ? x.entitY_NAME : "none"}</p>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <p className="mi_name">Agency FEIN</p>
                                            <p className="mi_value">{x.fein ? x.fein : "none"}</p>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <p className="mi_name">Agency NPN</p>
                                            <p className="mi_value">{x.npn ? x.npn : "none"}</p>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <p className="mi_name">State</p>
                                            <p className="mi_value">{x.statE_COMPANY_ID ? (States && States.find(y => y.code === x.statE_COMPANY_ID).name) : "none"}</p>
                                        </Col>




                                    </Row>

                                </div>
                            })}


                        </div> : ""}
                    <div className="mi_main" >
                        <Row span={24}>
                            <Col span={15}>
                                <p className='mi_title' style={{ color: '#fd828d' }}>Employment History</p>
                            </Col>
                        </Row>
                        {appoinment.employmenT_HISTORY && appoinment.employmenT_HISTORY.map((x, i) => {
                            return <div key={i}>

                                <Row>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">From Date</p>
                                        <p className="mi_value">{x.datE_FROM ? moment(x.datE_FROM).format("MM/YYYY") : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">To Date</p>
                                        <p className="mi_value">{x.datE_TO ? moment(x.datE_TO).format("MM/YYYY") : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">Employer's Name</p>
                                        <p className="mi_value">{x.employeR_NAME ? x.employeR_NAME : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">Position</p>
                                        <p className="mi_value">{x.position ? x.position : "none"}</p>
                                    </Col>

                                    <Col md={6} sm={24}>
                                        <p className="mi_name">City</p>
                                        <p className="mi_value">{x.city ? x.city : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">Country</p>
                                        <p className="mi_value">{x.countrY_CODE ? "United States of America" : "none"}</p>
                                    </Col>
                                    <Col md={6} sm={24}>
                                        <p className="mi_name">State</p>
                                        <p className="mi_value">{x.statE_CODE ? (States && States.find(y => y.code === x.statE_CODE).name) : "none"}</p>
                                    </Col>



                                </Row>

                            </div>
                        })}


                    </div>
                    <div className="mi_main" >
                        <Row span={24}>
                            <Col span={15}>
                                <p className='mi_title' style={{ color: '#fd828d' }}>Background</p>
                            </Col>
                        </Row>
                        {bqs.map((x, i) => {

                            return <div key={i}> <Row>
                                <Col sm={19}>
                                    <p style={{ fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: x.qno + ") " + x.question_Description }}></p>
                                    {x.deS1 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS1 }}></p> : ""}
                                    {x.deS2 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS2 }}></p> : ""}
                                    {x.deS3 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS3 }}></p> : ""}
                                    {x.deS4 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS4 }}></p> : ""}
                                    {x.deS5 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS5 }}></p> : ""}

                                </Col>
                                <Col sm={2}></Col>
                                <Col sm={3}>
                                    {this.getbgs(x.qno, x.bQDs)}

                                </Col>

                            </Row>
                                {x.bQs.map((y, i) => {

                                    return <Row key={i}>
                                        <Col sm={19}>
                                            <p style={{ fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: y.qno + ") " + y.question_Description }}></p>
                                            {y.deS1 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS1 }}></p> : ""}
                                            {y.deS2 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS2 }}></p> : ""}
                                            {y.deS3 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS3 }}></p> : ""}
                                            {y.deS4 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS4 }}></p> : ""}
                                            {y.deS5 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS5 }}></p> : ""}


                                        </Col>
                                        <Col sm={2}></Col>
                                        <Col sm={3}>
                                            {this.getbgs(y.qno, y.bQDs)}

                                        </Col>

                                    </Row>
                                })}
                                <Divider></Divider>
                            </div>
                        })}


                    </div>
                    {nuqs.length>0 ?
                        <div className="mi_main" >
                            <Row span={24}>
                                <Col span={15}>
                                    <p className='mi_title' style={{ color: '#fd828d' }}>Questions</p>
                                </Col>
                            </Row>
                            {nuqs.map((x, i) => {

                                return <div key={i}> <Row>
                                    <Col sm={19}>
                                        <p style={{ fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: x.lI_QUEST_NO + ") " + x.lI_QUEST }}></p>
                                        {x.deS1 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS1 }}></p> : ""}
                                        {x.deS2 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS2 }}></p> : ""}
                                        {x.deS3 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS3 }}></p> : ""}
                                        {x.deS4 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS4 }}></p> : ""}
                                        {x.deS5 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS5 }}></p> : ""}

                                    </Col>
                                    <Col sm={2}></Col>

                                    <Col sm={3}>
                                        {this.getnqs(x.lI_QUEST_NO, x.nQDs)}

                                    </Col>

                                </Row>
                                    {x.nQs.map((y, i) => {
                                        return <Row key={i}>
                                            <Col sm={19}>
                                                <p style={{ fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: y.qno + ") " + y.question_Description }}></p>
                                                {y.deS1 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS1 }}></p> : ""}
                                                {y.deS2 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS2 }}></p> : ""}
                                                {y.deS3 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS3 }}></p> : ""}
                                                {y.deS4 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS4 }}></p> : ""}
                                                {y.deS5 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: y.deS5 }}></p> : ""}


                                            </Col>                                <Col sm={2}></Col>

                                            <Col sm={3}>
                                                {this.getnqs(x.lI_QUEST_NO, y.nQDs)}
                                            </Col>

                                        </Row>
                                    })}
                                    <Divider></Divider>
                                </div>
                            })}


                        </div> : ""}
                    <div className="mi_main_div" >
                        <Row>
                            <Col md={24}>
                                <div className="collapsepanel-footer ">
                                    <Button className=" ant-btn mi_button_right" style={{ float: "left", marginTop: "-20px", marginLeft: "-11px" }} onClick={() => this.props.back("step")}> Back</Button>

                                    <Button className=" ant-btn-primary" onClick={this.props.submitHandlerStep}
                                        style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}>
                                        Next</Button> </div>
                            </Col>  </Row>
                    </div> </div >

                : "")
    }

}
export default NiprSummary;
